import React from "react";
import "./brandsPage.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchBrandProducts } from "../../features/product/productThunks";

import zara from "../../assets/images/ZaraImage.jpg";
import nike from "../../assets/images/NikeImage.jpg";
import adidas from "../../assets/images/AdidasImage.jpg";
import balenciga from "../../assets/images/BalencigaImage.png";
import chanel from "../../assets/images/ChannelImage.jpg";
import gucci from "../../assets/images/GucciImage.png";
import HandH from "../../assets/images/H&HImage.jpg";
import armain from "../../assets/images/ArmainImage.png";
import burberry from "../../assets/images/BurberryImage.jpg";
import dior from "../../assets/images/DiorImage.webp";
import levis from "../../assets/images/Levi'sImage.jpg";
import louis from "../../assets/images/LouisVuittonImage.jpg";
import lululemon from "../../assets/images/LululemonImage.webp";
import prada from "../../assets/images/PradaImage.webp";
import HandM from "../../assets/images/H&MImage.png";
import { clearProducts } from "../../features/product/productSlice";
import { Helmet } from "react-helmet";


export default function BrandsPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const brands = [
    { name: "Zara", img: zara },
    { name: "Nike", img: nike },
    { name: "Adidas", img: adidas },
    { name: "Balenciga", img: balenciga },
    { name: "Chanel", img: chanel },
    { name: "Gucci", img: gucci },
    { name: "H&H", img: HandH },
    { name: "Prada", img: prada },
    { name: "Armain", img: armain },
    { name: "Burberry", img: burberry },
    { name: "Dior", img: dior },
    { name: "Levi's", img: levis },
    { name: "Louis Vuitton", img: louis },
    { name: "Lululemon", img: lululemon },
    { name: "H&M", img: HandM }
  ];

  const handleBrandClick = (brandName) => {
    dispatch(clearProducts());
    navigate("/brands-products", {
      state: {
        brand: brandName,
        endPoint: `brand-products?brand=${brandName}`,
      },
    });
  };


  return (
    <>

      <Helmet>
        <title>SHOP.CO | Brands - Shop by Your Favorite Labels</title>
        <meta
          name="description"
          content="Discover top brands available on SHOP.CO. Browse and shop products from your favorite labels all in one place."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/brands/"
        />
      </Helmet>

      <div className="brandsPage-container">
        {brands.map((brand) => (
          <div className="brandsPage-card" key={brand.name} onClick={() => handleBrandClick(brand.name)}>
            <img src={brand.img} alt={brand.name} />
            <h2>{brand.name}</h2>
            <p>Leading the market in innovation</p>
          </div>
        ))}
      </div>
    </>
  );
}
